export const oauthGoogleKeys = {
  post_oauth_google: () => ['post_oauth_google'] as const
}
